<template>
    <div class="xc-page xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <a href="">系统设置</a>
                <a href="">角色管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            @submit.prevent="mix_search"
                        >
                            <div class="xc-form-inline">
                                <xc-form-item label="角色名称:">
                                    <input
                                        type="text"
                                        name="roleName"
                                        v-model="mix_query.roleName"
                                        class="xc-input"
                                        placeholder="请输入角色名称"
                                    >
                                </xc-form-item>
                                <xc-form-item label="角色状态:">
                                    <select
                                        name="status"
                                        v-model="mix_query.status"
                                        class="xc-select"
                                    >
                                        <option value="">全部</option>
                                        <option value="1">启用</option>
                                        <option value="0">禁用</option>
                                    </select>
                                </xc-form-item>

                                <div class="xc-btn-group">
                                    <button class="xc-btn xc-btn-primary">查询</button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="modalName='add'"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>角色名称</th>
                                    <th>角色状态</th>
                                    <th>备注</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.roleId}}</td>
                                        <td>{{item.roleName}}</td>
                                        <td>{{item.status|getStatus}}</td>
                                        <td>{{item.roleDesc}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                                v-if="item.roleId !== 1 && item.roleId !== 15 && item.roleId !== 20"
                                            >
                                                <template v-if="groups.length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="mix_pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>

        <!--弹窗-->
        <div class="xc-card">
            <!--添加-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='add'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">添加</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="角色名称:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="roleName"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="角色名称"
                                            placeholder="请输入角色名称"
                                            :class="{'xc-input-error':errors.first('roleName','add')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("roleName","add")}}
                                        </div>
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="角色状态:"
                                        required
                                        :error="errors.first('status','add')"
                                    >
                                        <select
                                            name="status"
                                            class="xc-select"
                                            v-validate="'required'"
                                            data-vv-as="角色状态"
                                        >
                                            <option
                                                value="1"
                                                selected
                                            >启用</option>
                                            <option value="0">禁用</option>
                                        </select>
                                    </xc-form-item>
                                </div>
                                <xc-form-item label="备注:">
                                    <input
                                        type="text"
                                        name="roleDesc"
                                        class="xc-input"
                                        placeholder="请输入备注"
                                    >
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">编辑</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form"
                                name="edit"
                                data-vv-scope="edit"
                            >
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="角色名称:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="roleName"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="角色名称"
                                            placeholder="请输入角色名称"
                                            :class="{'xc-input-error':errors.first('roleName','edit')}"
                                            v-model="current.roleName"
                                        >
                                        <input
                                            type="hidden"
                                            name="roleId"
                                            v-model="current.roleId"
                                        />
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("roleName","edit")}}
                                        </div>
                                    </xc-form-item>
                                    <xc-form-item
                                        label="角色状态:"
                                        required
                                        :error="errors.first('status','edit')"
                                    >
                                        <select
                                            name="status"
                                            class="xc-select"
                                            v-model="current.status"
                                            v-validate="'required'"
                                            data-vv-as="角色状态"
                                        >
                                            <option value="">请选择</option>
                                            <option value="1">启用</option>
                                            <option value="0">禁用</option>
                                        </select>
                                    </xc-form-item>
                                </div>
                                <xc-form-item label="备注:">
                                    <input
                                        type="text"
                                        name="roleDesc"
                                        class="xc-input"
                                        placeholder="请输入备注"
                                        v-model="current.roleDesc"
                                    >
                                </xc-form-item>
                                <div class="xc-form-inline">
                                    <xc-form-item label="创建时间:">
                                        <input
                                            type="text"
                                            name="addTime"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            placeholder=""
                                            v-model="current.addTime"
                                        >
                                    </xc-form-item>
                                    <xc-form-item label="最后修改时间:">
                                        <input
                                            type="text"
                                            name="updateTime"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            v-model="current.updateTime"
                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="操作人:">
                                        <input
                                            type="text"
                                            name="operator"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            v-model="current.operator"
                                        >
                                    </xc-form-item>
                                </div>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="editSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该角色?
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--启用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">启用</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定启用该角色？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="updateSubmit(1)"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--禁用弹窗-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">禁用</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定禁用该角色？禁用后该角色下所有用户账号不能使用
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="updateSubmit(0)"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import myLayerImport from '@/libs/myLayer';
import "@/libs/vee-validate"
import "@/utils/form-format"
import { getList, getTree } from "../api/department";
import role from "@/api/role"
import loadScript from '@/utils/load-script';



export default {
    name: 'departmentList',
    mixins: [listMixin],
    data() {
        return {
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            departments: [],

            // 默认查询参数
            mix_query: {
                roleName: "",
                status: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "设置权限",
                    id: 1,
                },
                {
                    name: "启用",
                    id: 3,
                },
                {
                    name: "禁用",
                    id: 4,
                },
                {
                    name: "删除",
                    id: 5
                }
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,   //当前表行
        }
    },
    filters: {
        getStatus: function (value) {
            //0表示禁用，1表示启用
            if (value == 0) {
                return "禁用"
            }
            return "启用";
        }
    },
    methods: {
        // 初始化数据
        initData() {

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            role.roleList(search).then((ret) => {
                // 添加mix_checkbox属性
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },
        groups: function (item) {
            var arr = this.group.slice(0);
            if (item.status == 0) {
                //1表示正常,0表示禁用
                arr.splice(3, 1);
            } else {
                arr.splice(2, 1)
            }
            return arr;
        },
        // 操作单条数据
        action(...args) {
            var _this = this;
            const [action, item, index] = args;
            const e = args[args.length - 1];
            this.current = { ...item };
            switch (action.id) {
                case 0:
                    this.modalName = "edit";
                    break;
                case 1:
                    //设置权限
                    this.$router.push(this.adminPath + "/system/authority-setting?roleId=" + this.current.roleId + "&roleName=" + this.current.roleName + "&status=" + this.current.status);
                    break;
                case 2:
                    this.modalName = "delete";
                    break;
                case 3:
                    this.modalName = "active";
                    break;
                case 4:
                    this.modalName = "disabled";
                    break;
                case 5:
                    this.modalName = "delete";
                    break;
                default:
                    break;
            }
        },
        //    添加确定
        addSubmit: function () {
            var _this = this;
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    return this.$formFormat(myForm);
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                }
            }).then(formData => {
                if (formData) {
                    role.save(formData).then(function (success) {
                        _this.$message.success("添加成功");
                        _this.modalName = null;
                        _this.initData();
                    }).catch(function (error) {
                        console.log(error)
                    })
                }
            })
        },
        //    编辑确定
        editSubmit: function () {
            var _this = this;
            // 验证器命名空间
            const scope = 'edit';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    return this.current;
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                }
            }).then(formData => {
                if (formData) {
                    role.update(formData).then(function (success) {
                        _this.$message.success("修改成功");
                        _this.modalName = null;
                        _this.initData();
                        /* setTimeout(function () {
                             location.href="";
                         },500)*/
                    }).catch(function (error) {
                        console.log(error)
                    })
                }
            })
        },

        //更改角色状态
        updateSubmit: function (type) {
            var _this = this;
            var obj = {
                roleId: this.current.roleId,
                status: ""
            };
            if (type == 1) {
                obj.status = 1;
            } else {
                obj.status = 0;
            }
            role.enableDisableRole(obj).then(function (success) {
                _this.$message.success("操作成功");
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
        },
        //    删除确定
        deleteSubmit: function () {
            var obj = {
                roleId: this.current.roleId,
            };
            role.delete(obj).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        },

        authSubmit: function () {

        }
    },
    async created() {
        loadScript("/libs/md5.js");

        myLayerImport();
    },
}
</script>

<style scoped lang="scss">
</style>

